<template>
  <div class="of-hidden">
    <div class="home-01">
      <el-row type="flex" justify="space-between" class="home-content">
        <el-col :span="12" class="m-t-15"
          ><img class="logo" src="../../assets/logo.png"
        /></el-col>
        <el-col :span="2" class="m-t-15">
          <el-button type="primary" @click="routerGo('/login')"
            >登录/注册</el-button
          ></el-col
        >
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        align="center"
        class="home-content"
      >
        <el-col :span="14" class="banner-text">
          <h1 class="an-frist">
            更简单的<span class="text-primary text-elarge">社交</span>媒体工具
          </h1>
          <h1 class="m-t-15 an-frist">
            实现<span class="text-success">真实参与</span>
          </h1>
          <div class="text f-20 an-frist-2">
            通过您可以信赖的发布，分析和参与平台，讲述您的品牌故事并扩大受众
          </div>
          <el-button class="btn-star an-frist-3" @click="routerGo('/login')"
            >开始使用吧</el-button
          >
        </el-col>
        <el-col :span="10" class="an-second"
          ><img class="home-01-img" src="../../assets/home_bg_01_1.png"
        /></el-col>
      </el-row>
    </div>
    <div class="home-02">
      <el-row type="flex" justify="space-between" class="home-content">
        <el-col :span="12"
          ><img
            class="home-02-img anFabugongju"
            src="../../assets/home_bg_02_1.jpg"
        /></el-col>
        <el-col :span="12" class="banner-text">
          <h4 class="f-24">发布工具</h4>
          <h1 class="f-40">简化并加强您的社交媒体发布</h1>
          <div class="text f-20">
            简单高效 · 轻轻松松 · 毫不费力 · 最大程度为您节省时间
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="home-03">
      <el-row class="home-content scroll-item" justify="space-between">
        <h1 class="f-40">
          集多账号管理、数据监测、一键发帖的全球社交媒体一站式管理平台
        </h1>
        <el-col :span="6">
          <img src="../../assets/home_bg_03_1.png" />
          <p class="f-20">数据监测</p>
        </el-col>
        <el-col :span="6">
          <img src="../../assets/home_bg_03_2.png" />
          <p class="f-20">协同发布</p>
        </el-col>
        <el-col :span="6">
          <img src="../../assets/home_bg_03_3.png" />
          <p class="f-20">素材管理</p>
        </el-col>
        <el-col :span="6">
          <img src="../../assets/home_bg_03_4.png" />
          <p class="f-20">重点跟踪</p>
        </el-col>
      </el-row>
    </div>
    <div class="home-04">
      <el-row
        type="flex"
        justify="space-between"
        class="home-content scroll-item"
      >
        <el-col :span="10" :offset="2" class="banner-text">
          <h1 class="f-40">数据监测</h1>
          <div class="text m-tb-50 f-20 an-04">
            支持Facebook等社交媒体平台跨平台多账号管理，<br />
            强大资料库支持，数据即时监测，<br />
            驱动行销自动化，释放数据价值<br />
            <el-button plain @click="routerGo('/login')">立即使用</el-button>
          </div>
        </el-col>
        <el-col :span="14"
          ><img class="home-02-img" src="../../assets/home_bg_04_1.png"
        /></el-col>
      </el-row>
    </div>
    <div class="home-05">
      <el-row type="flex" justify="space-between" class="home-content">
        <el-col :span="14"
          ><img
            class="home-02-img scroll-item-2"
            src="../../assets/home_bg_05_1.png"
        /></el-col>
        <el-col :span="10" class="banner-text scroll-itemXie">
          <h1 class="f-40">协同发布</h1>
          <div class="text m-tb-50 f-20">
            新版发帖工具支持四大海外社交媒体平台，<br />
            支持文字，图片，视频，链接等全主流样<br />
            式一键多平台多样式发布，<br />
            且支持自定义定时发布，贴文预览，<br />
            批量设定等使用功能<br />
            <el-button type="primary" plain @click="routerGo('/login')"
              >立即使用</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer">
      <h1>NothingDB</h1>
      <p>©copyright 2023 tools.nothingdb.com</p>
      <ul class="privacy">
        <li @click="routerGo('/policy')">隐私政策</li>
        <li style="margin: 0 5px">|</li>
        <li @click="routerGo('/clause')">服务条款</li>
      </ul>
    </div>
  </div>
</template>

<script>
import "animate.css";
import Wow from "wow.js";
import { onMounted } from "vue";

export default {
  methods: {
    routerGo(path) {
      this.$router.push(path);
    },
  },
  setup(props) {
    onMounted(() => {
      const wow = new Wow({
        // 对所有拥有该class的元素挂载动画
        boxClass: "scroll-item",
        // 需要挂载的动画元素
        animateClass: "scrollItem",
        // 偏移值（即偏移一定距离后再执行动画，推荐设置！）
        offset: 350,
        // 移动设备是否生效
        mobile: true,
        // 是否支持异步
        live: true,
      });
      const wow2 = new Wow({
        // 对所有拥有该class的元素挂载动画
        boxClass: "scroll-item-2",
        // 需要挂载的动画元素
        animateClass: "scrollItem2",
        // 偏移值（即偏移一定距离后再执行动画，推荐设置！）
        offset: 350,
        // 移动设备是否生效
        mobile: true,
        // 是否支持异步
        live: true,
      });
      const wowXieTong = new Wow({
        // 对所有拥有该class的元素挂载动画
        boxClass: "scroll-itemXie",
        // 需要挂载的动画元素
        animateClass: "bounceInUp",
        // 偏移值（即偏移一定距离后再执行动画，推荐设置！）
        offset: 350,
        // 移动设备是否生效
        mobile: true,
        // 是否支持异步
        live: true,
      });

      wow.init();
      wow2.init();
      wowXieTong.init();
    });
  },
};
</script>

<style lang="less" scoped>
@import "./navigation.less";
</style>
